import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const Title = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;

  svg {
    color: ${(props) => props.theme.color.blue.default};
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: 24px;

  > * {
    flex: 1;
  }

  ${mediaQuery(BREAKPOINTS.phone)} {
    flex-direction: column;
  }
`;
